import React from 'react'
import logo from '../assets/images/stoxbox-footer-logo-custom.png';

export const Footer = () => {
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '28px', paddingBottom: '10px' }}>
        <img src={logo} alt="img" />
      </div>
      <div>
        <p style={{ color: 'white', fontWeight: '1000', display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
        © 2023 BP Equities Pvt. Ltd. All Rights Reserved.
        </p>
      </div>
      <div>
        <p style={{ color: '#7c7a91', display: 'flex', justifyContent: 'center', marginBottom: 0, textAlign: 'center' }}>
          All subscription pricing plans mentioned across the website are exclusive of 18% GST.
        </p>
        <p style={{ color: '#7c7a91', display: 'flex', textAlign: 'center' }}>
          By signing up, you agree to receive transactional messages on Whatsapp. You may also receive a call from a StoxBox representative to help you with the account opening process.
        </p>
      </div>
    </>
  )
}
